import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}
const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtHearing(item) {
  return client.post("CourtHearings/CreateCourtHearing", prepareDataRequest(item));
}
function UpdateCourtHearing(item) {
  return client.post("CourtHearings/UpdateCourtHearing", prepareDataRequest(item));
}

function GetCourtHearings(courtCaseId) {
  return client.post("CourtHearings/GetCourtHearings/", prepareRequest({ courtCaseId }));
}
function DeleteCourtHearing(id, uid) {
  return client.post("CourtHearings/DeleteCourtHearing", prepareDataRequest({ id, commandUserId: uid }));
}


export {
  CreateCourtHearing,
  UpdateCourtHearing,
  GetCourtHearings,
  DeleteCourtHearing
}